
/*eslint-disable */

import {mapGetters, mapState} from 'vuex';

var $ = window.jQuery = require('jquery');
export default {
  name: 'contest-list',
  components: {
  },
  props: [],
  data() {
    return {
      rankLoader:true,
      previousContestList: [],
      domainLocationOrigin:''
    }
  },
  computed: {
  },
  mounted() {
    this.domainLocationOrigin = window.location.origin
    this.getPreviousContestList();
  },
  methods: {
    urlClipBoardMethod(value) {
      const copyUrl = this.domainLocationOrigin + '/interview/' + value
      navigator.clipboard.writeText(copyUrl) + '/'
    },
    getPreviousContestList() {
      this.$store.dispatch('getIvContestListAction')
        .then((res) => {
          if(res.data.results){
            this.previousContestList =  res.data.results;
            this.preQuizContestLoader = false
          }
        })
        .catch((err) => {})
    },
    dateFormatNumbringFun(date) {
      var d = moment(date).utc().format('DD')
      if (d > 3 && d < 21) return 'th';
      switch (d % 10) {
        case 1:  return "st";
        case 2:  return "nd";
        case 3:  return "rd";
        default: return "th";
      }
    },
  },
}
